<template>
    <router-link v-slot="{isActive, href, navigate}"
                 :to="to">
        <div @click="navigate" :href="href"
             class="d-flex flex-column justify-content-center align-items-center cursor-pointer">
            <transition name="grow" mode="in-out">
                <div v-if="isActive" class="position-absolute active-dot"></div>
            </transition>
            <component :is="icon" width="30" height="30" :active="isActive"/>
            <small class="d-flex" :class="{active: isActive}">
                <slot></slot>
            </small>
        </div>
    </router-link>
</template>

<script>
    import IPersonGradient from "../Icons/IPersonGradient";
    import IRecord from "../Icons/IRecord";
    import ILocation from "../Icons/ILocation";
    import IWallet from "../Icons/IWallet";
    import IMenu from "../Icons/IMenu";

    export default {
        name: "BottomNavigationItem",
        components: {IPersonGradient, IRecord, ILocation, IWallet, IMenu},
        props: {
            to: {
                type: [String, Object],
                required: true
            },
            icon: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>
    .active {
        font-weight: 700 !important;
    }

    .active-dot {
        height: 10px;
        width: 10px;
        top: -.3rem;
        border-radius: 50%;
        background-color: #3266F5;
    }

    small {
        color: #3266F5;
        font-size: 75%;
        transition: font-weight .2s;
    }
</style>
